import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { updateAdsConsent } from "@/lib/ads";

const KEY = "dv-cookie-consent";

function applyConsent(consent) {
  try {
    if (window.posthog) {
      if (consent && consent.statistiche) window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
  } catch (e) {}
  // Aggiorna Google Consent Mode v2 (Google Ads) in base alla scelta.
  updateAdsConsent(consent);
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event("dv-open-cookie"));
}

export function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(false);
  const [stats, setStats] = useState(false);
  const [mkt, setMkt] = useState(false);

  useEffect(() => {
    let stored = null;
    try {
      stored = JSON.parse(localStorage.getItem(KEY) || "null");
    } catch (e) {}
    if (stored) {
      applyConsent(stored);
      setStats(!!stored.statistiche);
      setMkt(!!stored.marketing);
    } else {
      applyConsent({ statistiche: false, marketing: false });
      setOpen(true);
    }
    const reopen = () => { setDetails(true); setOpen(true); };
    window.addEventListener("dv-open-cookie", reopen);
    return () => window.removeEventListener("dv-open-cookie", reopen);
  }, []);

  const save = (consent) => {
    try { localStorage.setItem(KEY, JSON.stringify({ ...consent, ts: Date.now() })); } catch (e) {}
    applyConsent(consent);
    setOpen(false);
    setDetails(false);
  };

  if (!open) return null;

  return (
    <div data-testid="cookie-banner" className="fixed inset-x-0 bottom-0 z-[70] p-4 sm:p-6">
      <div className="max-w-3xl mx-auto bg-graphite text-canvas border border-canvas/20 shadow-2xl p-6 md:p-8">
        <p className="font-serif text-2xl font-light">Rispetto della tua privacy</p>
        <p className="mt-3 text-sm text-canvas/70 leading-relaxed">
          Questo sito utilizza cookie tecnici necessari al funzionamento e, previo tuo consenso,
          cookie statistici e di marketing (Google Ads, per la sola misurazione delle conversioni).
          Puoi accettare, rifiutare o scegliere per categoria. Maggiori dettagli nella{" "}
          <Link to="/cookie-policy" className="link-underline text-canvas" onClick={() => setOpen(false)}>Cookie Policy</Link>.
        </p>

        {details && (
          <div className="mt-5 space-y-3 border-t border-canvas/15 pt-5">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-sm font-medium">Necessari</p>
                <p className="text-xs text-canvas/55">Indispensabili al funzionamento del sito. Sempre attivi.</p>
              </div>
              <span className="text-xs uppercase tracking-wide text-canvas/50 pt-1">Sempre attivi</span>
            </div>
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-sm font-medium">Statistiche</p>
                <p className="text-xs text-canvas/55">Ci aiutano a capire in forma aggregata come viene usato il sito.</p>
              </div>
              <label className="pt-1 inline-flex items-center cursor-pointer">
                <input
                  data-testid="cookie-toggle-stats"
                  type="checkbox"
                  checked={stats}
                  onChange={(e) => setStats(e.target.checked)}
                  className="h-4 w-4 accent-sage cursor-pointer"
                />
              </label>
            </div>
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-sm font-medium">Marketing</p>
                <p className="text-xs text-canvas/55">Misurazione delle conversioni pubblicitarie (Google Ads). Nessun remarketing né profilazione basata sulle pagine visitate.</p>
              </div>
              <label className="pt-1 inline-flex items-center cursor-pointer">
                <input
                  data-testid="cookie-toggle-marketing"
                  type="checkbox"
                  checked={mkt}
                  onChange={(e) => setMkt(e.target.checked)}
                  className="h-4 w-4 accent-sage cursor-pointer"
                />
              </label>
            </div>
          </div>
        )}

        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <button
            data-testid="cookie-reject"
            onClick={() => save({ statistiche: false, marketing: false })}
            className="order-2 sm:order-1 border border-canvas/40 px-6 py-3 text-xs uppercase tracking-[0.15em] hover:bg-canvas/10 transition-colors"
          >
            Rifiuta
          </button>
          {!details ? (
            <button
              data-testid="cookie-preferences"
              onClick={() => setDetails(true)}
              className="order-3 sm:order-2 border border-canvas/40 px-6 py-3 text-xs uppercase tracking-[0.15em] hover:bg-canvas/10 transition-colors"
            >
              Preferenze
            </button>
          ) : (
            <button
              data-testid="cookie-save"
              onClick={() => save({ statistiche: stats, marketing: mkt })}
              className="order-3 sm:order-2 border border-canvas/40 px-6 py-3 text-xs uppercase tracking-[0.15em] hover:bg-canvas/10 transition-colors"
            >
              Salva preferenze
            </button>
          )}
          <button
            data-testid="cookie-accept"
            onClick={() => save({ statistiche: true, marketing: true })}
            className="order-1 sm:order-3 bg-canvas text-graphite px-6 py-3 text-xs uppercase tracking-[0.15em] hover:opacity-90 transition-opacity"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}
